import { useEffect } from 'react';

/**
 * The callback function should return a boolean value to determine whether or not we should stop
 * event propagation. This lets us block scroll events while the text area is focused.
 *
 * @param {Function<boolean>} callback
 */
export const useTouchListener = callback => {
  useEffect(() => {
    const onTouch = e => {
      if (callback(e)) {
        e.stopPropagation();
        e.preventDefault();
      }
    };
    document.addEventListener('touchmove', onTouch, {
      passive: false
    });
    return () => {
      document.removeEventListener('touchmove', onTouch);
    };
  }, [callback]);
};